<ng-container *ngIf="form">
  <form [formGroup]="form">
    <mat-table [dataSource]="dataSource" class="update-table">

      <!-- businessName Column -->
      <ng-container matColumnDef="businessName">
        <mat-header-cell *matHeaderCellDef fxFlex>
          <span>{{ 'MASSIVE_COMPANY_DIALOG.BUSINESS_NAME' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" fxFlex>
          <span class="text-truncate"
                [matTooltip]="element.get('businessName').value">{{ element.get('businessName').value }}</span>
        </mat-cell>
      </ng-container>

      <!-- taxCode Column -->
      <ng-container matColumnDef="taxCode">
        <mat-header-cell *matHeaderCellDef fxFlex="130px">
          <span>{{ 'MASSIVE_COMPANY_DIALOG.TAX_CODE' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" fxFlex="130px">
          <span>{{ element.get('taxCodePrefix').value }} {{ element.get('taxCode').value }}</span>
        </mat-cell>
      </ng-container>

      <!-- transferType Column -->
      <ng-container matColumnDef="transferType">
        <mat-header-cell *matHeaderCellDef>
          <span>{{ 'MASSIVE_COMPANY_DIALOG.TRANSFER_TYPE' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" [formGroup]="element">
          <mat-form-field appearance="outline" fxFlexFill>
            <mat-select formControlName="transferType">
              <ng-container *ngFor="let tType of transferTypes">
                <mat-option [value]="tType" [disabled]="tType !== TransferType.ProSolutoConfirmNotification">
                  <span>{{ 'MASSIVE_COMPANY_DIALOG.' + tType | translate }}</span>
                </mat-option>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- existingInvoiceTotalAmount Column -->
      <ng-container matColumnDef="existingInvoiceTotalAmount">
        <mat-header-cell *matHeaderCellDef fxFlex="150px">
          <span>{{ 'MASSIVE_COMPANY_DIALOG.INVOICE_VALUE' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;" [formGroup]="element" fxFlex="150px">
          <mat-form-field appearance="outline" fxFlexFill>
            <input matInput currencyMask formControlName="existingInvoiceTotalAmount" />
            <span matSuffix>€</span>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <!-- trustRequired Column -->
      <ng-container matColumnDef="trustRequired">
        <mat-header-cell *matHeaderCellDef fxFlex="150px">
          <span>{{ 'MASSIVE_COMPANY_DIALOG.REQUIRED_OPERATING_LIMIT' | translate }}</span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element;" [formGroup]="element" fxFlex="150px">
          <mat-form-field appearance="outline" fxFlexFill>
            <input matInput currencyMask formControlName="trustRequired" />
            <span matSuffix>€</span>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </form>
</ng-container>
